import { render } from "./TextModal.vue?vue&type=template&id=4530fe69"
import script from "./TextModal.vue?vue&type=script&lang=js"
export * from "./TextModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__